import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubscribeStatesService {
  private _cardsUpdated = signal<number>(0);
  public readonly cardsUpdated = this._cardsUpdated.asReadonly();

  public notifyCardsUpdate(): void {
    this._cardsUpdated.update((n) => n + 1);
  }
}
